<mat-dialog-content>
  <div
    fxLayout="column"
    fxLayout.gt-sm="row wrap"
    fxLayoutAlign="center center"
    fxLayoutAlign.gt-xs="space-between center"
    class="modal-container"
  >
    <img
      src="/assets/icons/shapes/close.svg"
      alt="close"
      class="close-modal"
      (click)="this.dialogRef.close();"
    >
    <div
      fxLayout="column"
      fxLayoutAlign="space-between center"
      class="left"
    >
      <div
        class="image"
        [ngStyle]="{'background-image': 'url(' + image.width_320_url + ')'}">
      </div>
      <h3 class="title">
        {{ name }}
      </h3>
      <label>
        {{ job }}
      </label>
      <a
        *ngIf="link"
        mat-raised-button
        [href]="link"
        target="_blank"
      >
        Link
      </a>
    </div>
    <div
      fxLayout="column"
      fxLayoutAlign="space-between center"
      class="right"
    >
      <div class="description">{{ description }}</div>
      <button
        type="button"
        mat-raised-button
        color="main-color"
        class="close-modal-button"
        (click)="this.dialogRef.close();"
      >
        {{ 'buttons.close_window' | translate }}
      </button>
    </div>
  </div>
</mat-dialog-content>



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/modals/show-item-details-modal-base/show-item-details-modal-base.component.html